import { render, staticRenderFns } from "./SubscriptionStub.vue?vue&type=template&id=4c76a7ea&scoped=true&"
import script from "./SubscriptionStub.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStub.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionStub.vue?vue&type=style&index=0&id=4c76a7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c76a7ea",
  null
  
)

export default component.exports